'use client';

import type { ReactNode } from 'react';

import { ProductMarkThreeOrnament } from './product-mark-three-ornament';
import { createShelterSenseThreeScene } from './shelter-sense-three-scene';

type ShelterSenseThreeOrnamentProps = {
  /** Static logo markup shown until (and unless) the WebGL scene is live. */
  children: ReactNode;
};

/**
 * Client island wrapping the Shelter Sense showcase logo with the extruded
 * Three.js scene. Delegates lifecycle to ProductMarkThreeOrnament.
 */
export function ShelterSenseThreeOrnament({
  children,
}: ShelterSenseThreeOrnamentProps) {
  return (
    <ProductMarkThreeOrnament createScene={createShelterSenseThreeScene}>
      {children}
    </ProductMarkThreeOrnament>
  );
}
